export enum ApplicationsUrl {
    ios = 'https://apps.apple.com/ua/app/ФОПкаса/id1571983961',
    android = 'https://play.google.com/store/apps/details?id=com.fopkasa'
}
